import WithRoleAuthorization, {
    listOfRoles
} from 'components/WithRoleAuthorization/WithRoleAuthorization'
import { notificationStatus } from 'constants/notificationStatus'
import { ButtonAction } from 'pages/NotifyEvent/styles'
import { UserDataType } from 'types/autentication'

export interface IAssumeTreatment {
    currentUser: UserDataType
    handleAssumeNotification: () => void
    notificationStatusState: string
    actionsBack: string
    loggedInUserIsResponsible: boolean
    currentStepSelected: number
    notificationLocation: string
    notificationSector: string
}
export const checkSameSectorAndLocation = ({
    currentUser,
    notificationLocation,
    notificationSector
}: {
    currentUser: UserDataType
    notificationLocation: string
    notificationSector: string
}) => {
    const isSameLocation =
        currentUser?.locations?.filter((i) => i.sys_id === notificationLocation)
            .length > 0
    const isSameSector =
        isSameLocation &&
        currentUser?.locations
            ?.filter((i) => i.sys_id === notificationLocation)[0]
            ?.sectors.filter((i) => i.sys_id === notificationSector).length > 0
    
    return {
        isSameLocation,
        isSameSector
    }
}
export const assumeAllowedRules = ({
    isSameLocation,
    isSameSector
}: {
    isSameLocation: boolean
    isSameSector: boolean
}) => {
    return [
        listOfRoles.admin,
        ...(isSameLocation && isSameSector
            ? [listOfRoles.location_manager]
            : []),
        ...(isSameLocation ? [listOfRoles.location_qa] : [])
    ]
}
export default function AssumeTreatment({
    currentStepSelected,
    currentUser,
    handleAssumeNotification,
    actionsBack,
    notificationStatusState,
    loggedInUserIsResponsible,
    notificationSector,
    notificationLocation
}: IAssumeTreatment) {
    const {isSameLocation,isSameSector} = checkSameSectorAndLocation({currentUser,
      notificationLocation,
      notificationSector})
    const shouldRenderButton =
        (currentStepSelected === 1 || currentStepSelected === 5) &&
        (notificationStatusState === notificationStatus[1].label ||
            notificationStatusState === notificationStatus[2].label) &&
        !loggedInUserIsResponsible
    if (!shouldRenderButton) {
        return null
    }
    return (
        <WithRoleAuthorization
            allowedRoles={assumeAllowedRules({ isSameLocation, isSameSector })}
            userRole={currentUser?.profile}
            children={
                <ButtonAction
                    data-testid="test-assume-treatment-button"
                    type="button"
                    onClick={handleAssumeNotification}
                    className={actionsBack}
                >
                    Assumir tratamento
                </ButtonAction>
            }
        />
    )
}
